module.exports = __webpack_public_path__ + "static/2894c57b8cadfea71d3c7dd5fa67622fd5efc87fc1e190d2d0ce991533096df1-209db933eb97f7d2d2c5e002e1547216.jpeg";